import { useEffect, useState } from 'react';

/** Start optional reads only after the surface is open and near the viewport. */
export default function useNearViewport<T extends Element = HTMLDivElement>(enabled = true) {
  const [element, ref] = useState<T | null>(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    if (!enabled || !element || seen) return;
    if (typeof IntersectionObserver === 'undefined') {
      setSeen(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setSeen(true);
        observer.disconnect();
      }
    }, { rootMargin: '200px' });
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, enabled, seen]);
  return { ref, nearViewport: enabled && seen };
}
